const LoginAuthentication = () =>
  null;

export default LoginAuthentication;



/** WEBPACK FOOTER **
 ** ./src/components/Login/LoginAuthentication.js
 **/